// Theme configuration utility
// This file provides access to theme colors for use in non-CSS contexts (like URLs)

// Define the accent color here - this should match your tailwind.config.js
// To change the accent color, update both this file and tailwind.config.js
export const ACCENT_COLOR = '#3B82F6';
export const ACCENT_COLOR_HEX = '3B82F6';

// You can also define other theme constants here if needed
export const theme = {
  accent: ACCENT_COLOR,
  accentHex: ACCENT_COLOR_HEX,
  accentHover: '#60A5FA',
  accentPressed: '#2563EB'
};